import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';
import image from '../../../assets/shootinglocation.png';

// High-tech Cinema Location Icons
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import PanoramaRoundedIcon from '@mui/icons-material/PanoramaRounded';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import WbSunnyRoundedIcon from '@mui/icons-material/WbSunnyRounded';
import PowerRoundedIcon from '@mui/icons-material/PowerRounded';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';

const ShootingLocationsIndustry = () => {
  return (
    <IndustryPageTemplate
      title="Shooting Locations"
      subtitle="Discover, Scout & Book Verified Filming Locations"
      desc="Explore thousands of verified soundstages, iconic urban rooftops, historic castles, and scenic outdoor sets. Seamlessly book filming locations with 360° virtual tours and instant permit clearance."
      image={image}
      themeColor="#10b981"
      bgGradient="linear-gradient(135deg, rgba(16,185,129,0.2) 0%, rgba(16,185,129,0.02) 100%)"
      marqueeItems={[
        { icon: '📍', tag: 'SCOUTING', text: 'Warner Bros. booked 3 soundstages in London Studio Hub', time: '1m ago', color: '#10b981' },
        { icon: '🏛️', tag: 'HERITAGE', text: 'Rajasthan Royal Palace set approved for period drama filming', time: '3m ago', color: '#f59e0b' },
        { icon: '☀️', tag: 'SOLAR HUD', text: 'Golden hour sun path angle calibrated for Amalfi Coast exterior shoot', time: '6m ago', color: '#07a4f5' },
        { icon: '⚡', tag: 'POWER READY', text: '500kVA studio power connection certified for Panavision rig', time: '9m ago', color: '#8b5cf6' },
        { icon: '🛡️', tag: 'PERMITS', text: 'Municipal aerial drone filming permit cleared in under 12 hours', time: '14m ago', color: '#ec4899' },
        { icon: '🔒', tag: 'ESCROW', text: 'Smart contract deposit secured with 100% property insurance', time: '18m ago', color: '#06b6d4' },
      ]}
      features={[
        {
          id: 'soundstages',
          icon: <LocationOnRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Verified Soundstage Directory',
          desc: 'Acoustically isolated soundstages, cyclorama infinity walls, and LED volume production studios ready to shoot.',
          badge: 'Soundstages',
          metric: '1,200+ Studio Hubs',
          highlight: 'Acoustic Rated',
          hasPulse: true,
        },
        {
          id: 'scenic',
          icon: <PanoramaRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Scenic Outdoor & Urban Sets',
          desc: 'Scout iconic glass skyscrapers, desert expanses, rustic warehouses, and private beachfront properties worldwide.',
          badge: 'Scenic Spots',
          metric: '4K 360° Tours',
          highlight: 'Verified GPS',
        },
        {
          id: 'permits',
          icon: <VerifiedUserRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Instant Municipal Permits',
          desc: 'One-click automated city filming permit applications, street closure paperwork, and local authority clearance.',
          badge: 'Instant Permits',
          metric: '< 24h Approval',
          highlight: 'Legal Protected',
        },
        {
          id: 'solar',
          icon: <WbSunnyRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Sun Path & Drone Trajectory',
          desc: 'Live astronomical solar calculations, shadow projections, and drone no-fly zone altitude checks for any set.',
          badge: 'Sun Tracking',
          metric: 'Golden Hour HUD',
          highlight: 'Solar Trajectory',
          hasEqualizer: true,
        },
        {
          id: 'power',
          icon: <PowerRoundedIcon sx={{ fontSize: 26 }} />,
          title: '3-Phase Power & Logistics',
          desc: 'Detailed specs on 3-phase electrical drops, heavy generator parking, crew catering, and loading dock accessibility.',
          badge: 'Power Specs',
          metric: '500kVA Certified',
          highlight: 'Rigging Ready',
        },
        {
          id: 'escrow',
          icon: <SecurityRoundedIcon sx={{ fontSize: 26 }} />,
          title: 'Smart Escrow & Insurance',
          desc: 'Secure property booking with automated milestone payments, insurance coverage, and zero broker commissions.',
          badge: 'Smart Escrow',
          metric: '100% Insured',
          highlight: 'Zero Broker Fees',
        },
      ]}
    />
  );
};

export default ShootingLocationsIndustry;
